import React from 'react';
import CrudManager from '../../components/admin/CrudManager';
import { getBlog, createBlog, updateBlog, deleteBlog } from '../../utils/api';

const fields = [
  { name: 'title', label: 'Post Title', type: 'text', required: true },
  { name: 'excerpt', label: 'Excerpt / Summary', type: 'textarea', rows: 2, required: true },
  { name: 'content', label: 'Full Content', type: 'textarea', rows: 8 },
  { name: 'image', label: 'Featured Image', type: 'image' },
  { name: 'date', label: 'Date', type: 'text', placeholder: 'e.g. 15 जनवरी 2025' },
  { name: 'category', label: 'Category', type: 'select', options: [
    { value: 'nation-building', label: 'Nation Building' },
    { value: 'panch-parivartan', label: 'Panch Parivartan' },
    { value: 'rss', label: 'RSS' },
    { value: 'bharat-2047', label: 'Bharat 2047' },
    { value: 'leadership', label: 'Leadership' },
    { value: 'youth', label: 'Youth' },
    { value: 'culture', label: 'Culture' },
    { value: 'service', label: 'Service' },
    { value: 'general', label: 'General' },
  ]},
];

export default function AdminBlog() {
  return (
    <CrudManager
      title="Blog Posts"
      subtitle="Manage articles and blog posts"
      fields={fields}
      fetchFn={getBlog}
      createFn={createBlog}
      updateFn={updateBlog}
      deleteFn={deleteBlog}
      emptyDefaults={{ category: 'general' }}
      cardRenderer={(item) => (
        <div>
          {item.image && <img src={item.image} alt={item.title} className="w-full h-40 object-cover" />}
          <div className="p-4">
            <span className="inline-block mb-2 text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded-full capitalize">{(item.category || '').replace(/-/g, ' ')}</span>
            <h3 className="font-bold text-slate-900 line-clamp-2" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>{item.title}</h3>
            <p className="text-xs text-slate-400 mt-1">{item.date}</p>
          </div>
        </div>
      )}
    />
  );
}
